import { Content } from './style'

export default function AccordionContent({children, isActive}) {
    return (
        <Content active={isActive}>
            {children}
        </Content>
    )
}